import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { isMobile, browserName, isSafari } from 'react-device-detect';
import DescriptionWithiOS18Support from './Components/DescriptionWithiOS18Support';
import images from '../Theming/images';
import DescriptionWithBrowserNotSupported from './Components/DescriptionWithBrowserNotSupported';
import { useQuery } from '../Common/Hooks';

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  padding: 1rem 1.5rem;
  font-family: 'Fira Sans';
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const HyperisePlaceholderContainer = styled.div`
  width: 100%;
  height: fit-content;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const StyledLogo = styled.img`
  min-width: 3rem;
  width: 7%;

  opacity: 0;
  animation: ${fadeIn} 1s ease-in forwards;
  animation-delay: 2s;
`;

const PartnerPluginActivateBase = () => {
  const [showNotSupportedWarning, setShowNotSupportedWarning] = useState(false);
  const [
    overrideBackToAppButtonVisibility,
    setOverrideBackToAppButtonVisibility,
  ] = useState(false);
  const query = useQuery();

  useEffect(() => {
    // used if you want to edit not supported page on hyperise
    const notSafariOverride = query.get('notsafarioverride');
    // used if you want to edit back to app button styling on hyperise
    const backToAppButtonVisibility = query.get('backtoappbuttonvisibility');

    if (backToAppButtonVisibility) {
      setOverrideBackToAppButtonVisibility(true);
    }

    if ((isMobile && !isSafari) || notSafariOverride) {
      setShowNotSupportedWarning(true);
    }
  }, []);

  return (
    <Container id="mainContainer">
      <HyperisePlaceholderContainer id="beforeLogo">
        <p></p>
      </HyperisePlaceholderContainer>
      <LogoContainer id="logo">
        <StyledLogo
          src={images.purple_kindred_icon?.default}
          alt="kindred icon"
        />
      </LogoContainer>
      {!showNotSupportedWarning && (
        <HyperisePlaceholderContainer id="afterLogo">
          <p></p>
        </HyperisePlaceholderContainer>
      )}
      {!showNotSupportedWarning && (
        <HyperisePlaceholderContainer id="beforeDescription">
          <p></p>
        </HyperisePlaceholderContainer>
      )}
      {showNotSupportedWarning ? (
        <DescriptionWithBrowserNotSupported />
      ) : (
        <DescriptionWithiOS18Support
          overrideBackToAppButtonVisibility={overrideBackToAppButtonVisibility}
        />
      )}
    </Container>
  );
};

export default PartnerPluginActivateBase;
